module.exports = __webpack_public_path__ + "static/media/6-BIM钢结构计量GJG.816cfa8b.png";